import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  VStack,
  Button,
  Text,
  Select,
} from '@chakra-ui/react';
import { useSocket } from '../../contexts/SocketContext.tsx';
import { useTranslation } from 'react-i18next';

interface MultiplayerMysteryTargetSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onTargetSelected: () => void;
  gameState: any;
}

const MultiplayerMysteryTargetSelector: React.FC<MultiplayerMysteryTargetSelectorProps> = ({ 
  isOpen, 
  onClose, 
  onTargetSelected, 
  gameState 
}) => {
  const { t } = useTranslation();
  const { socket } = useSocket();
  const [selectedPlayer, setSelectedPlayer] = React.useState<string>('');
  const [selectedCategory, setSelectedCategory] = React.useState<string>('');

  console.log('🎯 MysteryTargetSelector - gameState:', gameState);

  const currentPlayer = gameState.players[gameState.currentPlayerIndex];
  const otherPlayers = gameState.players.filter(p => p.id !== currentPlayer.id);
  
  const playersWithStreak = otherPlayers.filter(player => {
    console.log(`🎯 Checking player ${player.name} (ID: ${player.id})`);
    console.log(`🎯 Player score:`, player.score);
    console.log(`🎯 Player completedCategories:`, player.completedCategories);
    
    const hasActiveStreak = Object.entries(player.score).some(([categoryId, score]) => {
      // Vérifier si la catégorie existe dans gameState.categories
      const category = gameState.categories.find(c => c.id === categoryId || c.category_key === categoryId);
      
      if (!category) {
        console.log(`🎯 Category not found for ID: ${categoryId}`);
        return false;
      }
      
      if (category.is_mystery) {
        console.log(`🎯 Category ${categoryId} is mystery, skipping`);
        return false;
      }
      
      const isCompleted = player.completedCategories.includes(categoryId);
      const hasScore = (score as number) > 0;
      
      console.log(`🎯 Category ${categoryId}: score=${score}, completed=${isCompleted}, hasScore=${hasScore}`);
      
      return hasScore && !isCompleted;
    });
    
    console.log(`🎯 Player ${player.name} hasActiveStreak: ${hasActiveStreak}`);
    return hasActiveStreak;
  });

  console.log('🎯 MysteryTargetSelector - playersWithStreak:', playersWithStreak);

  const getCategoriesWithStreak = (playerId: string) => {
    const player = gameState.players.find(p => p.id === parseInt(playerId));
    if (!player) {
      console.log('🎯 MysteryTargetSelector - player not found for ID:', playerId);
      return [];
    }
    
    console.log('🎯 MysteryTargetSelector - player found:', player);
    console.log('🎯 MysteryTargetSelector - player.score:', player.score);
    console.log('🎯 MysteryTargetSelector - player.completedCategories:', player.completedCategories);
    
    // Utiliser toutes les catégories du jeu (sauf mystère)
    const availableCategories = gameState.categories
      .filter(category => !category.is_mystery)
      .filter(category => {
        const score = player.score[category.id] || 0;
        const isCompleted = player.completedCategories.includes(category.id);
        console.log(`🎯 MysteryTargetSelector - catégorie ${category.id}: score=${score}, completed=${isCompleted}`);
        return score > 0 && !isCompleted;
      })
      .map(category => ({
        id: category.id,
        name: `${category.name} (${t('streakLabel')}: ${player.score[category.id]}/${gameState.streakToWin || 3})`,
      }));
      
    console.log('🎯 MysteryTargetSelector - availableCategories:', availableCategories);
    return availableCategories;
  };

  const handleSubmit = () => {
    if (selectedPlayer && socket) {
      console.log('🎯 Selecting mystery target:', {
        playerId: parseInt(selectedPlayer)
      });
      
      socket.emit('mystery-target-selected', {
        playerId: parseInt(selectedPlayer)
      });
      
      onTargetSelected();
      onClose();
      setSelectedPlayer('');
      setSelectedCategory('');
    }
  };

  React.useEffect(() => {
    setSelectedCategory('');
  }, [selectedPlayer]);

  const availableCategories = selectedPlayer ? getCategoriesWithStreak(selectedPlayer) : [];

  console.log('🎯 MysteryTargetSelector - availableCategories:', availableCategories);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent 
        bg="var(--gris-bleute)" 
        color="var(--texte-clair)"
        border="1px solid"
        borderColor="rgba(139, 148, 179, 0.2)"
      >
        <ModalHeader color="var(--magenta-vif)">{t('mysteryQuestionTitle')}</ModalHeader>
        <ModalBody>
          <VStack spacing={4} pb={4}>
            <Text textAlign="center">
              {t('mysteryQuestionDesc', { name: currentPlayer.name })}
            </Text>

            <Select
              placeholder={t('selectPlayerPlaceholder')}
              value={selectedPlayer}
              onChange={(e) => setSelectedPlayer(e.target.value)}
              bg="var(--nuit-profonde)"
              borderColor="rgba(139, 148, 179, 0.2)"
              _focus={{ borderColor: 'var(--bleu-electrique)' }}
            >
              {playersWithStreak.map(player => (
                <option key={player.id} value={player.id} style={{ backgroundColor: 'var(--nuit-profonde)' }}>
                  {player.name}
                </option>
              ))}
            </Select>

            <Button
              colorScheme="red"
              isDisabled={!selectedPlayer}
              onClick={handleSubmit}
              w="full"
            >
              {t('confirmButton')}
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default MultiplayerMysteryTargetSelector;
